<template>
    <div class="teamCell">
        <span>{{teamName}}</span>
        <v-tooltip lazy bottom v-for="(productCategory, index) in result.ProductCategories" :key="index">
        <template v-slot:activator="{ on }">
            <v-img v-on="on" contain :src="getProductCategoryIcon(productCategory.ProductCategoryName)" :alt="productCategory.ProductCategoryName" max-width="25" ></v-img>
        </template>
        {{productCategory.ProductCategoryName}}
    </v-tooltip> 
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    components: {

    },
    props: {
        teamID: {
            type: Number,
            required: true
        },
        teamName: {
            type: String,
            required: true
        }
    },
    data(){
        return {
          
        };
    },
    computed: {
        ...mapState("RosterStore", [
            "teamRosterResult"
        ]),
        result() {
            if(this.teamRosterResult == null) {
                return null
            } else {
                var teamResult = this.teamRosterResult.find(trr=> trr.TeamID == this.teamID);
                if(teamResult == null) {
                    return {
                        ProductCategories: []
                    }
                } else {
                    return teamResult;
                }
            }
        }
    },
    methods: {
     getProductCategoryIcon(productCategoryName) {
         if(productCategoryName.toLowerCase().includes('blackberries')) {
            return require('@/assets/Blackberries.png');
         } else if(productCategoryName.toLowerCase().includes('blueberries')) {
            return require('@/assets/Blueberries.png')
         } else if(productCategoryName.toLowerCase().includes('raspberries')) {
            return require('@/assets/Raspberries.png')
         } else if(productCategoryName.toLowerCase().includes('strawberries')) {
             return require('@/assets/Strawberries.png')
         } else {
            return require('@/assets/Berries.png')
         }
     }
    },
    created(){
        
    }
}
</script>

<style scoped>
    .teamCell {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        min-width: 100px;
    }
</style>

